import { ACTIONS, PhleboAdminTypes } from "../interfaces/actionTypes/GenomicsResearchinterface";

type InitialState = {
  pin_code: Array<any>;
  cities: Array<any>;
  areaList: Array<any>;
  data: any;
  users: any;
  usersRights: Array<any>;
  bookingoverview: Array<any>;
  client: Array<any>;
  dealer: Array<any>;
  institute: Array<any>;
  samplesAccessioning: Array<any>;
  projects: Array<any>;
  applications: Array<any>;
  displayCities: Array<any>;
  mediaUpload: Array<any>;
  sampleFilter: Array<any>;
  projectsFilter: Array<any>;
  FailedSamples: Array<any>;
  loading: any;
  userDetails: Array<any>;
  ProjectSamples: Array<any>;
  sampleAllData: Array<any>;
  fetchTickets: Array<any>;
  fetchLoginUser: Array<any>;
  fectchComments:Array<any>;
  fetchStatusByYear:Array<any>;

};

const initialState: InitialState = {
  pin_code: [],
  cities: [],
  areaList: [],
  data: {},
  users: {},
  usersRights: [],
  bookingoverview: [],
  client: [],
  dealer: [],
  institute: [],
  samplesAccessioning: [],
  projects: [],
  applications: [],
  displayCities: [],
  mediaUpload: [],
  sampleFilter: [],
  projectsFilter: [],
  FailedSamples: [],
  loading: [],
  userDetails: [],
  ProjectSamples: [],
  sampleAllData: [],
  fetchTickets: [],
  fetchLoginUser: [],
  fectchComments:[],
  fetchStatusByYear:[],

};

const CustomerLeadReducer = (
  state = initialState,
  action: PhleboAdminTypes) => {
  switch (action.type) {
    case ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case ACTIONS.GET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
        loading: false,
      };

      case ACTIONS.GET_STATUS_BY_YEAR:
      return {
        ...state,
        fetchStatusByYear: action.payload,
        loading: false,
      };
      case ACTIONS.GET_COMMENTS:
      return {
        ...state,
        fectchComments: action.payload,
        loading: false,
      };
    case ACTIONS.GET_LOGIN_USER:
      return {
        ...state,
        fetchLoginUser: action.payload,
        loading: false,
      };
    case ACTIONS.GET_TICKETS:
      return {
        ...state,
        fetchTickets: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PROJECTS:
      return {
        ...state,
        projects: action.payload,
        loading: false,
      };
    case ACTIONS.GET_FAILED_SAMPLES:
      return {
        ...state,
        FailedSamples: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PROJECTS_FILTER:
      return {
        ...state,
        projectsFilter: action.payload,
        loading: false,
      };
    case ACTIONS.GET_SAMPLE_ACCESSIONING_FILTER:
      return {
        ...state,
        sampleFilter: action.payload,
        loading: false,
      };
    case ACTIONS.UPLOAD_MEDIA_FILES:
      return {
        ...state,
        mediaUpload: action.payload,
        loading: false,
      };
    case ACTIONS.GET_DISPLAY_CITIES:
      return {
        ...state,
        displayCities: action.payload,
        loading: false,
      };
    case ACTIONS.GET_SAMPLE_ACCESSIONING:
      return {
        ...state,
        samplesAccessioning: action.payload,
        loading: false,
      };
    case ACTIONS.GET_APPLICATIONS:
      return {
        ...state,
        applications: action.payload,
        loading: false,
      };
    case ACTIONS.GET_BOOKING_OVERVIEW:
      return {
        ...state,
        bookingoverview: action.payload,
        loading: false,
      };
    case ACTIONS.GET_DEALER:
      return {
        ...state,
        dealer: action.payload,
        loading: false,
      };
    case ACTIONS.GET_INSTITUTE:
      return {
        ...state,
        institute: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CLIENT:
      return {
        ...state,
        client: action.payload,
        loading: false,
      };
    case ACTIONS.GET_BOOKING_STATUS_COUNT:
      return {
        ...state,
        bookingStatusCount: action.payload,
        loading: false,
      };
    case ACTIONS.GET_USERS_RIGHTS:
      return {
        ...state,
        usersRights: action.payload,
        loading: false,
      };
    case ACTIONS.GET_CITIES:
      return {
        ...state,
        cities: action.payload,
        loading: false,
      };
    case ACTIONS.GET_AREA:
      return {
        ...state,
        areaList: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PANEL_USERS:
      return {
        ...state,
        user_panel: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PIN_CODE:
      return {
        ...state,
        pin_code: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PROJECT_SAMPLES:
      return {
        ...state,
        ProjectSamples: action.payload,
        loading: false,
      };
    case ACTIONS.GET_PROJECTS_SAMPLE_ALL_DATA:
      return {
        ...state,
        sampleAllData: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default CustomerLeadReducer;
